import axios from "axios";
import LoggerUtils from "../utils/logger/LoggerUtils";
import TextConstants from "../utils/constants/TextConstants";

export const getSpecificTransaction = async (
  // token,
  transactionUuid,
  data = false
) => {
  try {
    const response = await axios.get(TextConstants.TRANSACTIONS_ENDPOINT, {
      params: {
        transaction_uuid: transactionUuid,
        data: data,
      },
      headers: {
        accept: "application/json",
        // authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    LoggerUtils.logError("fetching specific transaction", error);
    throw new Error(error.message);
  }
};

export const setTransactionDecision = async (
  token,
  transactionUuid,
  decision,
  inspectedPhysicalPassport,
  reasonForInspectedPhysicalPassport,
  riskAssessmentResult
) => {
  try {
    const response = await axios.post(
      TextConstants.TRANSACTIONS_ENDPOINT,
      null,
      {
        params: {
          transaction_uuid: transactionUuid,
          decision: decision,
          // actor: null,
          inspected_physical_passport: inspectedPhysicalPassport,
          reason_for_inspected_physical_passport:
            reasonForInspectedPhysicalPassport,
          risk_assessment_result: riskAssessmentResult,
        },
        headers: {
          accept: "application/json",
          // authorizati on: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    LoggerUtils.logError("setting transaction decision", error);
    throw new Error(error.message);
  }
};

export const getCarTransaction = async (transactionUuid) => {
  try {
    const response = await axios.get(TextConstants.CAR_TRANSACTIONS_ENDPOINT, {
      params: {
        transaction_uuid: transactionUuid,
      },
      headers: {
        accept: "application/json",
        // authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    LoggerUtils.logError("fetching car transaction", error);
    throw new Error(error.message);
  }
};

export const setCarTransactionDecision = async (
  token,
  transactionUuid,
  decision,
  inspectedCar,
  reasonForInspectedCar
) => {
  try {
    const response = await axios.post(
      TextConstants.CAR_TRANSACTIONS_ENDPOINT,
      null,
      {
        params: {
          transaction_uuid: transactionUuid,
          decision: decision,
          // actor: null,
          inspected_car: inspectedCar,
          reason_for_inspected_car: reasonForInspectedCar,
        },
        headers: {
          accept: "application/json",
          // authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    LoggerUtils.logError("setting car transaction decision", error);
    throw new Error(error.message);
  }
};
